/*
 * 1A "Discover" — Newsletter welcome popup (Task 6.3)
 *
 * Shows the modal rendered by snippets/newsletter-popup.liquid once per
 * visitor, throttled via localStorage. Trigger: after `data-delay` seconds
 * OR on exit-intent (mouse leaving toward the top of the viewport on
 * desktop). Close, "Nein danke", overlay-click and Escape all dismiss the
 * popup AND set the throttle flag. A successful real Shopify customer-form
 * submit (form.posted_successfully? -> data-posted="true") shows the
 * success state immediately and also sets the flag.
 */
(function () {
  if (window.__pixkomPopupInit) return;
  window.__pixkomPopupInit = true;

  var STORAGE_KEY = 'pk_nl_seen';

  function hasBeenSeenRecently(throttleDays) {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return false;
      var data = JSON.parse(raw);
      if (!data || !data.ts) return false;
      var elapsedDays = (Date.now() - data.ts) / 86400000;
      return elapsedDays < throttleDays;
    } catch (e) {
      return false;
    }
  }

  function markSeen() {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ ts: Date.now() }));
    } catch (e) {
      /* localStorage unavailable (private mode / disabled) — degrade
         gracefully: the popup may show again next visit. */
    }
  }

  function init() {
    var root = document.querySelector('[data-pk-nlpop]');
    if (!root) return;

    /* Defensive path check — theme.liquid already skips rendering the
       snippet on the cart page; this covers any other entry point. */
    var path = window.location.pathname || '';
    if (/^\/cart\b/.test(path) || /^\/checkout\b/.test(path)) return;

    var overlay = root.querySelector('[data-pk-nlpop-overlay]');
    var card = root.querySelector('[data-pk-nlpop-card]');
    var closeBtn = root.querySelector('[data-pk-nlpop-close]');
    var dismissBtn = root.querySelector('[data-pk-nlpop-dismiss]');
    var delaySeconds = parseInt(root.getAttribute('data-delay'), 10) || 8;
    var throttleDays = parseInt(root.getAttribute('data-throttle-days'), 10) || 7;
    var posted = root.getAttribute('data-posted') === 'true';
    var hasError = root.getAttribute('data-error') === 'true';

    var lastFocused = null;
    var openTimer = null;
    var isOpen = false;

    function getFocusable() {
      var nodes = card.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      return Array.prototype.filter.call(nodes, function (el) {
        return el.offsetParent !== null;
      });
    }

    function onKeydown(e) {
      var key = e.key || '';
      if (key === 'Escape' || e.keyCode === 27) {
        e.preventDefault();
        close();
        return;
      }
      if (key !== 'Tab' && e.keyCode !== 9) return;
      var focusable = getFocusable();
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    function clearTriggers() {
      if (openTimer) {
        window.clearTimeout(openTimer);
        openTimer = null;
      }
      document.removeEventListener('mouseleave', onExitIntent);
    }

    function open() {
      if (isOpen) return;
      clearTriggers();
      isOpen = true;
      lastFocused = document.activeElement;
      root.hidden = false;
      /* Double rAF so the "hidden -> visible" state paints before the
         transition class is added (matches pixkom-cart-popup.liquid). */
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          root.classList.add('pk-nlpop--open');
        });
      });
      document.addEventListener('keydown', onKeydown);
      var focusable = getFocusable();
      (focusable[0] || card).focus();
    }

    function close() {
      if (!isOpen) return;
      isOpen = false;
      root.classList.remove('pk-nlpop--open');
      document.removeEventListener('keydown', onKeydown);
      markSeen();
      var prefersReducedMotion =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.setTimeout(
        function () {
          root.hidden = true;
        },
        prefersReducedMotion ? 0 : 300
      );
      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
    }

    function onExitIntent(e) {
      if (e.clientY <= 0) open();
    }

    if (closeBtn) closeBtn.addEventListener('click', close);
    if (dismissBtn) dismissBtn.addEventListener('click', close);
    if (overlay) overlay.addEventListener('click', close);

    if (posted) {
      /* Real Shopify customer-form post-back: show the success state
         right away, skip timers/exit-intent, throttle future visits. */
      isOpen = true;
      root.hidden = false;
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          root.classList.add('pk-nlpop--open');
        });
      });
      document.addEventListener('keydown', onKeydown);
      markSeen();
      return;
    }

    if (hasError) {
      /* Form came back with validation errors: reopen immediately so the
         inline error is visible right away — but do NOT throttle, so the
         user can correct the email and retry. Normal close paths still set
         the seen flag if they give up. */
      isOpen = true;
      root.hidden = false;
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          root.classList.add('pk-nlpop--open');
        });
      });
      document.addEventListener('keydown', onKeydown);
      return;
    }

    if (hasBeenSeenRecently(throttleDays)) return;

    openTimer = window.setTimeout(open, delaySeconds * 1000);

    /* Exit-intent only makes sense with a mouse (desktop); skip it on
       coarse-pointer/touch devices. */
    if (!window.matchMedia || window.matchMedia('(pointer: fine)').matches) {
      document.addEventListener('mouseleave', onExitIntent);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
